import { render } from "./ZielgruppenBox.vue?vue&type=template&id=2111c667"
import script from "./ZielgruppenBox.vue?vue&type=script&lang=ts"
export * from "./ZielgruppenBox.vue?vue&type=script&lang=ts"

import "./ZielgruppenBox.vue?vue&type=style&index=0&id=2111c667&lang=scss"
script.render = render

export default script